import React from "react";
import { AsCardFragment } from "types/graphql-types";
import { ComponentBackgroundColor } from "types/componentBackground";
import LinkCard, { LinkCardProps } from "components/Card/LinkCard";
import { fromAsCard } from "./utils";

export interface AsCardSlideProps {
  card: AsCardFragment;
  fullPath?: string;
  cardBackgroundColor?: ComponentBackgroundColor;
  trackingName?: string;
  imageRatio?: LinkCardProps["imageRatio"];
}

const AsCardSlide: React.FC<AsCardSlideProps> = ({
  card,
  fullPath,
  cardBackgroundColor = "neutral05",
  imageRatio
}) => {
  const props = {
    ...fromAsCard(card),
    url: fullPath,
    trackingName: undefined,
    imageRatio
  };

  return <LinkCard backgroundColor={cardBackgroundColor} {...props} />;
};

export default AsCardSlide;
